import { deleteAssignment } from "@/api/assignments/deleteAssignment"
import { useMutation } from "@tanstack/react-query"

export const useDeleteAssignment = () => {

  return useMutation({
    mutationKey: ["deleteAssignment"],
    mutationFn: (deleteAssignmentId: string) => deleteAssignment(deleteAssignmentId)
  })
}